import { DeviceVariable, VariablesTableFilters } from '@iot-platform/models/i4b';

export class DeviceVariablesHelper {
  static filterVariables(variables: DeviceVariable[], filters: Partial<VariablesTableFilters>): DeviceVariable[] {
    return variables
      .filter((variable: DeviceVariable) =>
        variable['name'] && filters['name'] ? variable.name.toLowerCase().includes(filters['name'].toLowerCase()) : !(!variable['name'] && filters['name'])
      )
      .filter((variable: DeviceVariable) => (filters['linked'] === true || filters['linked'] === false ? variable['linked'] === filters['linked'] : true))
      .filter((variable: DeviceVariable) =>
        variable['comment'] && filters['description']
          ? variable['comment'].toLowerCase().includes(filters['description'].toLowerCase())
          : !(!variable['comment'] && filters['description'])
      )
      .filter((variable: DeviceVariable) => {
        if (variable['group'] && filters['group'] && filters['group'].value) {
          return variable['group'].toUpperCase() === filters['group'].value.toUpperCase();
        } else if (filters['group']?.value === '') {
          return !variable['group'];
        } else {
          return !(!variable['group'] && filters['group']);
        }
      })
      .filter((variable: DeviceVariable) => {
        if (variable['file'] && filters['file'] && filters['file'].value) {
          return variable['file'].toUpperCase() === filters['file'].value.toUpperCase();
        } else if (filters['file']?.value === '') {
          return !variable['file'];
        } else {
          return !(!variable['file'] && filters['file']);
        }
      });
  }

  static getDeviceVariableGroup(deviceVariables: DeviceVariable[]): { key: string; value?: string }[] {
    return deviceVariables.reduce(
      (acc: { key: string; value?: string }[], dVar: DeviceVariable) => {
        if (dVar.group) {
          const dVarGroup: { key: string; value: string } = { key: dVar.group, value: dVar.group };

          if (!acc.find((el) => el.key === dVarGroup.key)) {
            acc.push(dVarGroup);
          }
        }
        return acc;
      },
      [
        { key: 'DEVICES.INFO_TOOLBAR.ALL_GROUPS', value: undefined },
        { key: 'DEVICES.INFO_TOOLBAR.NO_GROUP', value: '' }
      ]
    );
  }

  static getDeviceVariableFiles(deviceVariables: DeviceVariable[]): { key: string; value?: string }[] {
    return deviceVariables.reduce(
      (acc: { key: string; value?: string }[], dVar) => {
        if (dVar.file) {
          const dVarFile: { key: string; value: string } = { key: dVar.file, value: dVar.file };

          if (!acc.find((el) => el.key === dVarFile.key)) {
            acc.push(dVarFile);
          }
        }
        return acc;
      },
      [
        { key: 'DEVICES.INFO_TOOLBAR.ALL_FILES', value: undefined },
        { key: 'DEVICES.INFO_TOOLBAR.NO_FILE', value: '' }
      ]
    );
  }

  static addFileInfoToDeviceVariables(deviceVariables: DeviceVariable[]): DeviceVariable[] {
    return deviceVariables.map((deviceVariable) => {
      let name = deviceVariable.name;
      let file = '';

      if (deviceVariable.name?.includes('[FILE]')) {
        name = deviceVariable.name.substring(deviceVariable.name.indexOf('/') + 1);
        file = deviceVariable.name.substring(deviceVariable.name.indexOf(']') + 1, deviceVariable.name.indexOf('/'));
      }
      return {
        ...deviceVariable,
        name,
        file,
        value: deviceVariable.lastValue?.value ?? null,
        time: deviceVariable.lastValue?.datetime ?? null
      };
    });
  }
}
